import React, { useState } from "react";
import { MdDelete, MdEdit } from "react-icons/md";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "./style.css";

function FinancialGovernance(props) {

    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    return (
        <div className="bg-white p-3">
            <div className="d-flex justify-content-end mb-2">
                <button className='btn btn-primary' onClick={() => setAddModal(true)}>वित्तीय सुशासन थप्नुहोस</button>
                <Modal isOpen={addModal} toogle={() => setAddModal(false)} scrollable className="custom-modal h-100" style={{ height: "100%" }}>
                    <ModalBody className="px-0 h-100" >
                        <div className="border-bottom px-2 d-flex justify-content-between ">
                            <p>वित्तीय सुशासन थप्नुहोस</p>
                            <p className="px-4" onClick={() => setAddModal(false)}>X</p>
                        </div>
                        <form>
                            <div>
                                <div className='formdiv'>
                                    <label className='formlabel'>अपेक्षित परिणाम</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>संकेत नम्बर</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>पहिचान भएका संभावित जाखिमहरु</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>जोखिमको वर्गीकरण</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>जोखिम न्यूनीकरणका लागि अवलम्बन गरिने उपाय</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>समय सीमा</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>माइलस्टोन/मापनको आधार र श्रोतहरु</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <label className='formlabel'>जिम्मेवार व्यक्ति निकाय</label>
                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                </div>
                                <div className='formdiv'>
                                    <button className="btn btn-primary">Submit</button>
                                </div>
                            </div>

                        </form>

                    </ModalBody>
                </Modal>
            </div>
            <div>
                <table className='table table-bordered text-center'>
                    <thead style={{ backgroundColor: "#F6F6F6" }}>
                        <tr>
                            <th>अपेक्षित परिणाम</th>
                            <th>संकेत नम्बर</th>
                            <th >पहिचान भएका संभावित जाखिमहरु</th>
                            <th >जोखिमको वर्गीकरण</th>
                            <th>जोखिम न्यूनीकरणका लागि अवलम्बन गरिने उपाय</th>
                            <th >समय सीमा</th>
                            <th >माइलस्टोन/मापनको आधार र श्रोतहरु</th>
                            <th>जिम्मेवार व्यक्ति निकाय</th>
                            <th >कार्यहरू</th>
                        </tr>
                    </thead>
                    <tbody>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>Test</td>
                        <td>

                            <div>
                                <button className="btn" onClick={() => setEditModal(true)}>
                                    <MdEdit>Edit</MdEdit>
                                </button>

                                <button className="btn" onClick={() => setDeleteModal(true)}>
                                    <MdDelete>Delete</MdDelete>
                                </button>
                            </div>
                            <Modal isOpen={editModal} toogle={() => setEditModal(false)}>
                                <ModalBody className="px-0 ">
                                    <div className="border-bottom px-2 d-flex justify-content-between">
                                        <p>Test</p>
                                        <p className="px-4" onClick={() => setEditModal(false)}>X</p>
                                    </div>
                                    <form>
                                        <div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>अपेक्षित परिणाम</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>संकेत नम्बर</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>पहिचान भएका संभावित जाखिमहरु</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>जोखिमको वर्गीकरण</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>जोखिम न्यूनीकरणका लागि अवलम्बन गरिने उपाय</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>समय सीमा</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>माइलस्टोन/मापनको आधार र श्रोतहरु</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <label className='formlabel'>जिम्मेवार व्यक्ति निकाय</label>
                                                <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                            </div>
                                            <div className='formdiv'>
                                                <button className="btn btn-primary">Submit</button>
                                            </div>
                                        </div>

                                    </form>

                                </ModalBody>
                            </Modal>

                            <Modal size="sm" centered style={{ maxWidth: '600px', width: '100%' }} isOpen={deleteModal} toogle={() => setDeleteModal(false)}>
                                <ModalBody className="px-0 ">
                                    <div className="d-flex flex-column justify-content-center align-items-center border-bottom py-3">
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <img style={{ maxHeight: 64, maxWidth: "64px" }} alt="Delete Icon" />
                                        </div>
                                        <div className="d-flex flex-column justify-content-center align-items-center text-center">
                                            <p syle={{ fontWeight: 700, fontSize: "14px", fontFamily: "Mukta" }}>वित्तीय सुशासन रद्द गर्ने?</p>
                                            <span className="text-center" style={{ fontSize: "14px", fontWeight: 400, fontFamily: "Mukta", color: "#5C6C74" }}>के तपाइँ यो वित्तीय सुशासन रद्दगर्न चाहनु हुन्छ? यो कार्य परिवर्तन गर्न सकिँदैन।</span>
                                        </div>
                                    </div>

                                    <form onSubmit={(e) => {
                                        setDeleteModal(false);
                                    }}>
                                        <div className="d-flex justify-content-center px-4 pt-2">
                                            <button type="button" className=" btn btn fw-bold bg-danger text-white col-6" onClick={() => setDeleteModal(false)}>होइन</button>
                                            <button type="submit" className=" btn btn fw-bold  mx-2 bg-primary text-white col-6">हो</button>
                                        </div>

                                    </form>

                                </ModalBody>
                            </Modal>

                        </td>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default FinancialGovernance;